import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlateLogoHorizontalDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 517,
	height: 160,
	viewBox: "0 0 517 160",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2873_10623)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M80 0C124.183 0 160 35.8172 160 80C160 124.183 124.183 160 80 160C35.8172 160 0 124.183 0 80C0 35.8172 35.8172 0 80 0ZM100 35C84.8122 35 72.5 47.3122 72.5 62.5C72.5 77.6878 84.8122 90 100 90C115.188 90 127.5 77.6878 127.5 62.5C127.5 47.3122 115.188 35 100 35Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M243.628 105.442C254.246 105.442 262.21 100.419 262.21 89.814C262.21 79.2093 254.386 75.0233 243.767 75.0233H228.538V105.442H243.628ZM208 157.628V58H245.165C268.637 58 282.609 71.5349 282.609 89.3954C282.609 108.093 266.122 122.326 245.025 122.326H228.538V157.628H208Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M311.238 58V157.628H291.398V58H311.238Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M324.199 107.674C326.434 95.3954 336.773 83.1163 355.774 83.1163C377.011 83.1163 387.49 94.6977 387.49 114.512V139.07C387.49 144.651 387.77 152.744 388.887 157.628H369.327C368.908 155.535 368.628 153.023 368.628 151.209V147.302H368.489C365.275 153.163 359.128 159.581 346.413 159.581C331.045 159.581 320.985 150.651 320.985 137.953C320.985 118.419 344.038 115.907 353.958 114.512C363.179 113.256 368.209 112.279 368.209 106C368.209 100.558 363.319 97.4884 355.914 97.4884C349.208 97.4884 344.318 101.395 342.501 107.674H324.199ZM340.685 136.837C340.685 141.442 344.178 145.488 352.142 145.488C360.665 145.488 368.489 140.605 368.489 124.14V119.116C366.812 122.326 362.9 125.256 353.679 127.209C344.318 129.023 340.685 132.093 340.685 136.837Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M423.76 128.186C423.76 137.395 424.878 142.419 433.261 142.419H437.731V157.907L428.231 158.047C409.09 158.465 404.479 146.884 404.479 131.256V100.279H392.603V85.4884H404.479V69.4419L423.76 60.9302V85.4884H438.43V100.279H423.76V128.186Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M515.882 136.419C511.411 150.512 498.697 160 480.674 160C458.738 160 443.23 144.512 443.23 121.488C443.23 99.3023 459.157 83.2558 480.953 83.2558C504.845 83.2558 516.86 100.837 517 123.163C517 124 517 125.535 516.86 127.07H462.091C463.628 137.535 470.893 144.233 480.674 144.233C487.52 144.233 493.388 141.86 496.042 136.419H515.882ZM462.231 114.372H497.999C497.021 106.14 491.851 98.0465 480.674 98.0465C470.754 98.0465 463.908 104.605 462.231 114.372Z",
				fill: "black"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2873_10623",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 517,
			height: 160,
			fill: "white"
		})
	}) })]
});
export default SvgPlateLogoHorizontalDark;
